module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: _vm.containerStyle
  }, _vm._l((_vm.data), function(item, i) {
    return _c('div', {
      key: 'skid-' + i,
      ref: "skid",
      refInFor: true,
      staticClass: ["wxc-skid"],
      style: {
        width: (750 + item.right.length * 100) + 'px',
        height: _vm.height + 'px'
      },
      on: {
        "click": function($event) {
          _vm.onNodeClick(item, i)
        },
        "touchstart": function (e) { return !_vm.isAndroid && _vm.onPanStart(e, item, i); },
        "horizontalpan": function (e) { return _vm.isAndroid && _vm.onPanStart(e, item, i); },
        "touchend": function (e) { return _vm.onPanEnd(e, item, i); }
      }
    }, [_c('div', {
      staticClass: ["swipe-action-center", "border"],
      style: _vm.styles
    }, [_vm._t("default", null, {
      val: {
        item: item,
        index: i
      }
    })], 2), _c('div', {
      staticClass: ["swipe-action-right"]
    }, _vm._l((item.right), function(child, childIdx) {
      return _c('text', {
        key: 'child-' + childIdx,
        staticClass: ["swipe-action-child", "swipe-action-text"],
        style: Object.assign({
          lineHeight: _vm.height + 'px'
        }, child.style || {}),
        on: {
          "click": function($event) {
            _vm.onRightNode(item, child, i)
          }
        }
      }, [_vm._v(_vm._s(child.text))])
    }))])
  }))
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-c855898a!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-swipe-action/index.vue
// module id = 238
// module chunks = 0 1